export default __webpack_public_path__ + "static/media/draupadi-blck.131fc7e2.jpeg";